import { AdminCreateUserRequest, AdminEditUserRequest } from "@shared/zod/schemas/requests/admin"
import { PageRequest } from "@shared/zod/schemas/requests/page"
import { AdminUsersPageResponse, AdminUserWithAuthorizationResponse } from "@shared/zod/schemas/responses/admin"
import { DefaultResponse } from "@shared/zod/schemas/responses/common"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const getAll = async (query?: PageRequest): Promise<AdminUsersPageResponse> => {
  const resp = await axiosAuth({
    url: "/admin/users",
    method: "get",
    params: query,
  })
  return resp.data
}

export const get = async (id: string): Promise<AdminUserWithAuthorizationResponse> => {
  const resp = await axiosAuth({
    url: `/admin/users/${id}`,
    method: "get",
  })
  return resp.data
}

export const create = async (data: AdminCreateUserRequest): Promise<DefaultResponse> => {
  const resp = await axiosAuth({
    url: "/admin/users",
    method: "post",
    data,
  })
  return resp.data
}

export const edit = async (id: string, data: AdminEditUserRequest): Promise<DefaultResponse> => {
  const resp = await axiosAuth({
    url: `/admin/users/${id}`,
    method: "patch",
    data,
  })
  return resp.data
}

export const reactivate = async (id: string): Promise<DefaultResponse> => {
  const resp = await axiosAuth({
    url: `/admin/users/${id}/reactivate`,
    method: "patch",
  })
  return resp.data
}

export const resetMFA = async (id: string): Promise<DefaultResponse> => {
  const resp = await axiosAuth({
    url: `/admin/users/${id}/totp`,
    method: "patch",
  })
  return resp.data
}
